import firebase from "../Firebase";
import 'firebase/functions';

const REGION_TOKYO = "asia-northeast1";

export default class CheckToken {

  check(token) {
    return new Promise((resolve, reject) => {
      const onCall = firebase.app().functions(REGION_TOKYO).httpsCallable('entryHostPayeeTokenCall');
      try {
        onCall({token: token})
          .then((result) => {
            resolve(result.data);
          });
      } catch(e) {
        reject(e);
      }
    })
  }
  register(token) {
    return new Promise((resolve, reject) => {
      //const onCall = firebase.app().functions(REGION_TOKYO).httpsCallable('entryHostPayeeTokenCall2');
      const onCall = firebase.app().functions(REGION_TOKYO).httpsCallable('frontAggregationCall');
      try {
        onCall({token: token, call: "entryHostPayeeTokenCall2"})
          .then((result) => {
            resolve(result.data);
          });
      } catch(e) {
        reject(e);
      }
    })
  }
  share_item(token) {
    return new Promise((resolve, reject) => {
      //const onCall = firebase.app().functions(REGION_TOKYO).httpsCallable('checkHostPayeeInsuranceItemShareTicketCall');
      const onCall = firebase.app().functions(REGION_TOKYO).httpsCallable('frontAggregationCall');
      try {
        onCall({token: token, call: "checkHostPayeeInsuranceItemShareTicketCall"})
          .then((result) => {
            resolve(result.data);
          });
      } catch(e) {
        reject(e);
      }
    })
  }
  checkRelation(token) {
    return new Promise((resolve, reject) => {
      //const onCall = firebase.app().functions(REGION_TOKYO).httpsCallable('entryHostPayeeRelationTokenCall');
      const onCall = firebase.app().functions(REGION_TOKYO).httpsCallable('frontAggregationCall');
      try {
        onCall({token: token, call: 'entryHostPayeeRelationTokenCall'})
          .then((result) => {
            console.log(result);
            resolve(result.data);
          });
      } catch(e) {
        reject(e);
      }
    })
  }
  checkSharedFamily(token) {
    return new Promise((resolve, reject) => {
      //const onCall = firebase.app().functions(REGION_TOKYO).httpsCallable('entryHostPayeeSharedFamilyToolTicketCall');
      const onCall = firebase.app().functions(REGION_TOKYO).httpsCallable('frontAggregationCall');
      try {
        onCall({token: token, call: "entryHostPayeeSharedFamilyToolTicketCall"})
          .then((result) => {
            resolve(result.data);
          });
      } catch(e) {
        reject(e);
      }
    })
  }
  checkBusinessRelation(token) {
    return new Promise((resolve, reject) => {
      //const onCall = firebase.app().functions(REGION_TOKYO).httpsCallable('entryHostPayeeBusinessRelationTokenCall');
      const onCall = firebase.app().functions(REGION_TOKYO).httpsCallable('frontAggregationCall');
      try {
        onCall({token: token, call: "entryHostPayeeBusinessRelationTokenCall"})
          .then((result) => {
            resolve(result.data);
          });
      } catch(e) {
        reject(e);
      }
    })
  }
}
